import React from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

interface Product {
  id: number;
  name: string;
  companyName?: string;
}

interface ProductSelectorProps {
  selectedProducts: number[];
  onProductsChange: (products: number[]) => void;
  error?: string;
  products: Product[];
}

const ProductSelector: React.FC<ProductSelectorProps> = ({
  selectedProducts,
  error,
  products,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const selectedProductNames = products?.filter((product) =>
    selectedProducts.includes(product.id)
  );

  return (
    <div className="w-full">
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Products
      </label>
      <div className="mb-2 flex flex-wrap gap-2">
        {selectedProductNames.map((product) => (
          <span
            key={product.id}
            className="inline-flex items-center px-2.5 py-0.5 rounded-full text-sm bg-blue-100 text-blue-800"
          >
            {product.name}
          </span>
        ))}
      </div>

      <div className="relative">
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="w-full bg-gray-100 border rounded-md py-2 px-3 text-left shadow-sm cursor-not-allowed outline-none border-gray-300"
        >
          <span className="flex items-center justify-between">
            <span className="block truncate">
              {selectedProducts.length === 0
                ? "No products selected"
                : `${selectedProducts.length} product(s) selected`}
            </span>
            {isOpen ? (
              <FaChevronUp className="text-gray-400" />
            ) : (
              <FaChevronDown className="text-gray-400" />
            )}
          </span>
        </button>

        {error && <p className="mt-1 text-sm text-red-500">{error}</p>}

        {isOpen && (
          <div className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-96 rounded-md border border-gray-300">
            <div className="overflow-auto max-h-72">
              {products.map((product) => (
                <div
                  key={product.id}
                  className="px-3 py-2 bg-gray-50 flex items-center"
                >
                  <input
                    type="checkbox"
                    checked={selectedProducts.includes(product.id)}
                    readOnly
                    disabled
                    className="mr-2 cursor-not-allowed"
                  />
                  <span className="text-gray-600">{product.name}</span>
                </div>
              ))}

              {products.length === 0 && (
                <div className="p-4 text-center text-gray-500">
                  No products available
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductSelector;
